import Vue from 'vue';
import Login from './components/user/Login';
import UserList from './components/user/UserList';
import UserInfo from './components/user/UserInfo';
import UserAddForm from './components/user/form/UserAddForm'
import UserTeamsEditForm from './components/user/form/UserTeamsEditForm';
import UserOverallInfo from './components/user/form/UserOverallInfo';
import UserResetPassword from './components/user/form/UserResetPassword';
import ChangePassword from './components/user/ChangePassword';
import WorkerList from '@/components/worker/WorkerList';
import WorkerProfile from '@/components/worker/WorkerProfile';
import WorkerAdd from '@/components/worker/form/WorkerAdd';
import WorkerPersonalInfo from '@/components/worker/form/WorkerPersonalInfo';
import WorkerContactInfo from '@/components/worker/form/WorkerContactInfo';
import VueRouter from 'vue-router';
import WorkerProfessionalProfile from "@/components/worker/form/WorkerProfessionalProfile";
import WorkerDocuments from "@/components/worker/form/WorkerDocuments";
import TeamList from "@/components/team/TeamList";
import TeamOverview from "@/components/team/TeamOverview";
import TeamInfo from "@/components/team/form/TeamInfo";
import TeamMembersList from "@/components/team/form/TeamMembersList";
import ProfessionList from "@/components/worker/ProfessionList";
import CompanyList from "@/components/worker/CompanyList";
import PageNotFound from "@/shared/components/page/PageNotFound";
import WorkerNotes from "@/components/worker/form/WorkerNotes";
import CarInfo from "@/components/car/CarInfo";
import DocumentList from "@/components/document/DocumentList";
import DocumentPreview from "@/components/document/DocumentPreview";
import CarList from "@/components/car/CarList";
import CarAdd from "@/components/car/form/CarAdd";
import CarDocuments from "@/components/car/document/CarDocuments";
import CarDocumentPreview from "@/components/car/document/CarDocumentPreview";
import CarOverallInfo from "@/components/car/form/CarOverallInfo";
import CarNotes from "@/components/car/form/CarNotes";
import CarVignettes from "@/components/car/form/CarVignettes";

Vue.use(VueRouter);

const routes = [
    {path: '/', component: Login},
    {path: '/login', component: Login},
    {path: '/change-password', component: ChangePassword},
    {path: '/users', component: UserList},
    {path: '/users/add', component: UserAddForm},
    {
        path: '/users/:id', component: UserInfo,
        children: [
            {path: 'information', component: UserOverallInfo},
            {path: 'reset-password', component: UserResetPassword},
            {path: 'teams', component: UserTeamsEditForm}
        ]
    },
    {path: '/staff', component: WorkerList},
    {path: '/staff/add', component: WorkerAdd},
    {
        path: '/staff/:id', component: WorkerProfile,
        children: [
            {path: 'personal-information', component: WorkerPersonalInfo},
            {path: 'contacts', component: WorkerContactInfo},
            {path: 'professional-experience', component: WorkerProfessionalProfile},
            {path: 'documents', component: WorkerDocuments},
            {path: 'notes', component: WorkerNotes}
        ]
    },
    {path: '/cars', component: CarList},
    {path: '/cars/add', component: CarAdd},
    {
        path: '/cars/:id', component: CarInfo,
        children: [
            {path: 'information', component: CarOverallInfo},
            {path: 'vignettes', component: CarVignettes},
            {path: 'documents', component: CarDocuments},
            {path: 'notes', component: CarNotes}
        ]
    },
    {path: '/teams', component: TeamList},
    {
        path: '/teams/:id', component: TeamOverview,
        children: [
            {path: 'overview', component: TeamInfo},
            {path: 'staff', component: TeamMembersList}
        ]
    },
    {path: '/documents', component: DocumentList},
    {path: '/documents/:id', component: DocumentPreview},
    {path: '/cars/documents/:id', component: CarDocumentPreview},
    {path: '/professions', component: ProfessionList},
    {path: '/companies', component: CompanyList},
    {path: "*", component: PageNotFound}
];

const router = new VueRouter({
    routes,
    base: 'app',
    mode: 'history'
});

export default router;
